import { Modal, Container } from "react-bootstrap";
import React from "react";


function ViewModal(props) {
  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} size={props.size} centered>
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="col-sm-12">
            {props.withHeader && (
              <div className="col-sm-12">
                <span className="custom-modal-body-title">
                  {" "}
                  VIEW {props.title}{" "}
                </span>
              </div>
            )}
            <Container fluid className="modal-cont justify-content-center">
              {props.children}
            </Container>
            {props.withButtons && (
              <div className="col-sm-12 mt-3 d-flex justify-content-end">
                <button className="button-primary  me-3" onClick={props.onEdit}>
                  Edit
                </button>
                <button
                  className="button-secondary mr-3"
                  onClick={props.onHide}
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

ViewModal.defaultProps = {
  title: "",
  type: "",
  size: "xl",
  withButtons: false,
  withHeader: false,
  show: () => {},
  onHide: () => {},
  onEdit: () => {},
};

export default ViewModal;
